<template>
	<Dialog id="inputBoxDialog" ref="dialogRef" v-focustrap :visible="visible" :header="title" :show-header="showHeader" modal
		style="z-index: 999; max-width: 90vw; min-width: 90vw;" :closable="false" :pt="{

			mask: {
				style: 'backdrop-filter: blur(2px)',
			},

		}" @show="onInputBoxShow">
		<div class="flex flex-column gap-2">
			<R3Input ref="inputBoxRef" v-model:input-value="inputBox" @keydown:enter="onInputBoxScanValue" />
			<div class="flex flex-row justify-content-end">
				<R3Button severity="danger" @click="onCancelInputBox">Cancelar</R3Button>
			</div>
		</div>
	</Dialog>
</template>

<script setup lang="ts">
import { nextTick } from 'vue';
import { useKeyboardAvoidance } from '~/composables/useKeyboardAvoidance';

// const props = withDefaults(defineProps<{
// 	visible: boolean,
// 	title: string,
// 	defaultValue?: string,
// }>(),
// 	{
// 		visible: false,
// 		defaultValue: ""
// 	});


const { visible, defaultValue, handleResponse, password, title } = useR3Inputbox();

// const emits = defineEmits(["update:cancelInput"])


// lifeCycle

// Keyboard avoidance — created once at component level (not inside onInputBoxShow)
const keyboardAvoidance = useKeyboardAvoidance();

// Ref to the PrimeVue Dialog component (for accessing its $el)
const dialogRef = useTemplateRef<InstanceType<typeof import('primevue/dialog').default>>('dialogRef');


// visibilidade

const showHeader = computed(() => Boolean(title));



// Input box
const inputBoxRef = useTemplateRef("inputBoxRef");
const inputBox = computed({
	get: () => defaultValue.value,
	set: (newValue: string) => {
		defaultValue.value = newValue;
	}

});

async function onInputBoxShow() {
	// Existing barcode scan focus behavior — must be preserved
	inputBoxRef.value?.setFocus({ limparCampo: true });

	// Attach keyboard avoidance to the dialog root element after the dialog is rendered
	await nextTick();
	const dialogEl = dialogRef.value?.$el as HTMLElement | undefined;
	if (dialogEl) {
		keyboardAvoidance.attach(dialogEl);
	}
}

function onCancelInputBox() {
	// emits("update:cancelInput", false);
	keyboardAvoidance.detach();
	visible.value = false;
}

function onInputBoxScanValue() {

	handleResponse(inputBox.value);
	keyboardAvoidance.detach();
	defaultValue.value = "";
	visible.value = false;
}


</script>

<style></style>